import { render, staticRenderFns } from "./VerticalTabs.vue?vue&type=template&id=3b07cd42&scoped=true"
import script from "./VerticalTabs.vue?vue&type=script&lang=js"
export * from "./VerticalTabs.vue?vue&type=script&lang=js"
import style0 from "./VerticalTabs.vue?vue&type=style&index=0&id=3b07cd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b07cd42",
  null
  
)

export default component.exports